/*
  Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except
  in compliance with the License. A copy of the License is located at

      http://aws.amazon.com/apache2.0/

  or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

/*
  Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except
  in compliance with the License. A copy of the License is located at

      http://aws.amazon.com/apache2.0/

  or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as log from 'loglevel';

import './index.css';
import RootRouter from './components/Routers/RootRouter';
// import registerServiceWorker from './registerServiceWorker'; // {unregister}
import { unregister } from './registerServiceWorker'; // {unregister}
import configureStore from './redux/store/configureStore';
import Config from './config';
import { hydrate } from 'react-dom';

log.setLevel(Config.logLevel);

const store = configureStore;

// https://medium.com/@brianhan/hot-reloading-cra-without-eject-b54af352c642
const render = (Component) => {
  return ReactDOM.render(
    <Provider store={store}>
      {/* <React.StrictMode> */}
      <Component />
      {/* </React.StrictMode> */}
    </Provider>,
    document.getElementById('root')
  );
};

const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
  hydrate(RootRouter, rootElement);
} else {
  render(RootRouter, rootElement);
}

// registerServiceWorker();
unregister();

// Comment out these lines to disable "true" hot reloading
// if (module.hot) {
//   module.hot.accept('./components/Routers/RootRouter', () => {
//     const NextApp = require('./components/Routers/RootRouter').default;
//     render(NextApp);
//   });
// }
